module.exports = __webpack_public_path__ + "static/media/phone.af1c1b12.svg";